import { getNestedProperty } from "../../utils/nestedObjectHelper";

const isEmptyValue = (value) => {
  return value === "";
};

const fieldCondition = (value = "", config) => {
  if (config.isNotEmpty) {
    return !isEmptyValue(value);
  }

  if (config.isEmpty) {
    return isEmptyValue(value);
  }

  if (config.pattern) {
    const regExpPattern = RegExp(config.pattern, config.flags);

    return config.notMatch
      ? !regExpPattern.test(value)
      : regExpPattern.test(value);
  }

  if (typeof config.is === "function") {
    return config.is(value, config);
  }

  if (Object.prototype.hasOwnProperty.call(config, "greaterThan")) {
    return value > config.greaterThan;
  }

  if (Object.prototype.hasOwnProperty.call(config, "greaterThanOrEqualTo")) {
    return value >= config.greaterThanOrEqualTo;
  }

  if (Object.prototype.hasOwnProperty.call(config, "lessThan")) {
    return value < config.lessThan;
  }

  if (Object.prototype.hasOwnProperty.call(config, "lessThanOrEqualTo")) {
    return value <= config.lessThanOrEqualTo;
  }

  if (Object.prototype.hasOwnProperty.call(config, "isBoolean")) {
    return value === config.isBoolean;
  }

  if (Object.prototype.hasOwnProperty.call(config, "isFalse")) {
    return value === false;
  }

  if (value === null) {
    return false;
  }

  const isMatched = Array.isArray(config.is)
    ? !!config.is.includes(value)
    : value?.toString()?.toLowerCase() === config?.is?.toLowerCase();

  return config.notMatch ? !isMatched : isMatched;
};

export const parseCondition = (condition = [], values, field = null) => {
  const positiveResult = {
    visible: true,
    ...condition.then,
    result: true,
  };

  const negativeResult = {
    visible: false,
    ...condition.else,
    result: false,
  };

  if (Array.isArray(condition)) {
    return !condition
      .map((cond) => {
        return parseCondition(cond, values, field);
      })
      .some(({ result }) => {
        return result === false;
      })
      ? positiveResult
      : negativeResult;
  }

  if ("show" in condition) {
    return condition?.show ? positiveResult : negativeResult;
  }

  if (condition.and) {
    return !condition.and
      .map((cond) => {
        return parseCondition(cond, values, field);
      })
      .some(({ result }) => {
        return result === false;
      })
      ? positiveResult
      : negativeResult;
  }

  if (condition.sequence) {
    return condition.sequence.reduce(
      (acc, curr) => {
        const result = parseCondition(curr, values);

        return {
          sets: [...acc.sets, ...(result.set ? [result.set] : [])],
          visible: acc.visible || result.visible,
          result: acc.result || result.result,
        };
      },
      { ...negativeResult, sets: [] }
    );
  }

  if (condition.or) {
    return condition.or
      .map((cond) => {
        return parseCondition(cond, values, field);
      })
      .some(({ result }) => {
        return result === true;
      })
      ? positiveResult
      : negativeResult;
  }

  if (condition.not) {
    return !parseCondition(condition.not, values).result
      ? positiveResult
      : negativeResult;
  }

  const finalWhen =
    typeof condition.when === "function"
      ? condition.when(field)
      : condition.when;

  if (typeof finalWhen === "string") {
    const fieldValue = getNestedProperty(values, finalWhen);
    return fieldCondition(fieldValue, condition)
      ? positiveResult
      : negativeResult;
    // return fieldCondition(get(values, finalWhen), condition)
    //   ? positiveResult
    //   : negativeResult;
  }

  if (Array.isArray(finalWhen)) {
    return finalWhen
      .map((fieldName) => {
        const fieldValue = getNestedProperty(
          values,
          typeof fieldName === "function" ? fieldName(field) : fieldName
        );
        return fieldCondition(fieldValue, condition);
        // return fieldCondition(
        //   get(
        //     values,
        //     typeof fieldName === "function" ? fieldName(field) : fieldName
        //   ),
        //   condition
        // );
      })
      .find((cond) => {
        return !!cond;
      })
      ? positiveResult
      : negativeResult;
  }

  return negativeResult;
};
